import React, { FC, useEffect, useState } from "react";
import { registerSetLoading } from '../../utils/loading.util';
import { LoadingContext } from "../LoadingContext";

export const LoadingProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    registerSetLoading(setLoading);
  }, []);

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};
